import {AfterViewInit, ChangeDetectionStrategy, Component, signal} from '@angular/core';
import {NgClass, NgOptimizedImage} from "@angular/common";
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/all";
import {TranslatePipe} from "@ngx-translate/core";
import {SafeHtmlPipe} from "../../../pipes/safe-html.pipe";

@Component({
  selector: 'app-home-iphone',
  imports: [
    NgOptimizedImage,
    NgClass,
    TranslatePipe,
    SafeHtmlPipe
  ],
  templateUrl: './home-iphone.component.html',
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HomeIphoneComponent implements AfterViewInit {
  
  ngAfterViewInit(): void {
    gsap.registerPlugin(ScrollTrigger);
    ScrollTrigger.defaults({
      start: 'top 80%'
    })
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: '.home-answer-section',
      }
    });

    tl.addLabel('start')
      .from('#answers-section-title', {
        opacity: 0,
        y: 60,
        duration: 0.3,
      })
      .from('.answer-chat', {
        opacity: 0,
        duration: 0.2,
      })
      .from('.answer-chat__item', {
        opacity: 0,
        y: 30,
        duration: 0.3,
        stagger: 0.7,
      })
    ;
  }
}
